var checkbox = {
  sizes: {
    small: {
      width: '16px',
      height: '16px'
    },
    regular: {
      width: '24px',
      height: '24px'
    },
    large: {
      width: '32px',
      height: '32px'
    }
  },
  circleSizes: {
    small: {
      width: '6px',
      height: '6px'
    },
    regular: {
      width: '10px',
      height: '10px'
    },
    large: {
      width: '14px',
      height: '14px'
    }
  }
};
export default checkbox;